import styled from 'styled-components';

import { Actions, Body, Disclaimer, Heading, InnerContent } from 'components/dialog';

import {
  ActionWrapper as DefaultActionWrapper,
  ImageContainer as DefaultImageContainer,
  OptInDialog as DefaultOptInDialog,
  LoadingAnimationWrapper as LoadingWrapper,
} from './loyalty-opt-in-modal.styled.default';

export * from './loyalty-opt-in-modal.styled.default';

export const LoadingAnimationWrapper = styled(LoadingWrapper)`
  max-width: 100%;
  margin: 0 auto;
  padding: 0;
  width: 200px;
  height: 200px;
`;

export const ImageContainer = styled(DefaultImageContainer)`
  max-width: 100%;
  margin-block-start: 0;
  margin-block-end: -2rem;
`;

export const OptInDialog = styled(DefaultOptInDialog)`
  max-width: 21.875rem;
  overflow-y: hidden;

  &[data-reach-dialog-content] {
    background-color: ${Styles.color.primary};
    border-radius: 20px;
    color: ${Styles.color.white};
  }

  ${Heading} {
    font-size: 1.625rem;
    margin-block-end: 2.5rem;
  }

  ${InnerContent} {
    padding-block-start: 0;
    padding-block-end: 2.25rem;
    padding-inline: 2.8125rem;
  }

  ${Body} {
    padding: 0;
    line-height: 1.125rem;
  }

  ${Actions} {
    button {
      width: fit-content;
      margin-block-start: 1.25rem;
      margin-block-end: 0;
      margin-inline: auto;
      padding: 0.8125rem 2rem;
      background-color: ${Styles.color.loyaltyHighlight};
    }
  }

  ${Disclaimer} {
    margin-block-start: 0.875rem;

    & * {
      font-family: ${Styles.fontFamily.brand};
      text-decoration: none;
      text-transform: capitalize;
      color: ${Styles.color.white};
    }
  }
`;

export const ActionWrapper = styled(DefaultActionWrapper)`
  margin: 0;
`;
